import * as libphonenumber from "google-libphonenumber";
import { z } from "zod";

const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();

export const phoneNumberSchema = z.string().refine(
  (value: string) => {
    try {
      if (!phoneUtil.isValidNumber(phoneUtil.parse(value))) {
        return false;
      }
      return true;
    } catch {
      return false;
    }
  },
  {
    message:
      "Please enter a valid international phone number with country code (e.g., +1234567890)",
  },
);
